import React from "react";

export const FieldError = ({ msg, testid }) => (msg ? <p className="text-xs text-destructive mt-1" role="alert" data-testid={testid}>{msg}</p> : null);

export const errCls = (msg) => (msg ? "border-destructive" : "");

export const focusFirstError = () => {
  setTimeout(() => {
    const el = document.querySelector('[aria-invalid="true"]');
    if (el) {
      el.scrollIntoView({ block: "center", behavior: "smooth" });
      const target = el.matches("input,select,textarea,button") ? el : el.querySelector("input:not([readonly]),select,textarea,button");
      (target || el).focus?.({ preventScroll: true });
    }
  }, 60);
};

export const ErrorSummary = ({ items, title = "Prima di inviare controlla:", testid = "form-error-summary" }) => (items.length ? (
  <div className="rounded-lg border border-destructive/40 bg-destructive/5 p-3 text-sm" role="alert" data-testid={testid}>
    <p className="font-medium text-destructive">{title}</p>
    <ul className="mt-1 list-disc pl-5 text-xs text-muted-foreground space-y-0.5">{items.map((m) => <li key={m}>{m}</li>)}</ul>
  </div>
) : null);
